import React from "react";
import {
  Layout,
  Space,
  Button,
  PageHeader,
  Divider,
  Card,
  Row,
  Col,
} from "antd";
import { useHistory } from "react-router-dom";
import OverviewCard from "../../components/Card/OverviewCard";
import { getLocalISODate } from "../../utils";

const { Content } = Layout;

const OrderDashboard = () => {
  const history = useHistory();
  return (
    <Layout className="u-page-layout tips-layout">
      <Content className="w-full page-padding">
        <Space className="w-full" direction="vertical">
          <PageHeader
            className=" page-header"
            title={`Orders (${getLocalISODate()})`}
            extra={[
              <Button
                type="primary"
                onClick={() => history.push("/delivery/manage-orders")}
              >
                Manage Orders
              </Button>,
            ]}
          />
        </Space>
        <div className="text-left">
          <OverviewCard title={60} subTitle="Total orders received today" className="min_kpi_card_size"/>
        </div>
        <Divider plain></Divider>
        <Space className="w-full" direction="vertical">
          <PageHeader
            className="page-header"
            title="Drivers"
            extra={[
              <Button
                type="primary"
                onClick={() => history.push("/delivery/manage-drivers")}
              >
                Manage Drivers
              </Button>,
            ]}
          />
        </Space>
        <div className="text-left">
          <OverviewCard title={8} subTitle="Total Delivery Drivers" className="min_kpi_card_size"/>
        </div>
        <Divider plain />
       
          <PageHeader className="page-header" title="KPIs, tips," />
        
        <Row gutter={[16, 16]} className="mb-1">
          <Col xs={24} md={11} lg={11}>
            <Card
              title="Branch wise sales"
              className="text-left shadow-lg rounded-md"
              headStyle={{ color: "#C32340" }}
            >
              <div className="px-1">
                <table className="w-full">
                  <tbody>
                    <tr>
                      <td>
                        <h4>Savage Burrito - Forth worth</h4>
                        <h5>
                          Orders Recieved: <span className="theme-red">17</span>
                        </h5>
                      </td>
                      <td className="text-right">
                        <strong className="ml-1">$649</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
          </Col>
          <Col xs={24} md={11} lg={11}>
            <Card
              title="Average Delivery Time"
              className="text-left shadow-lg rounded-md"
              headStyle={{ color: "#C32340" }}
            >
              <div className="px-1">
                <table className="w-full">
                  <tbody>
                    <tr>
                      <td>
                      Average Delivery time (today):
                      </td>
                      <td className="text-right theme-red">
                        <strong className="ml-1">38 min</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default OrderDashboard;
